const t = "styles-module__lawyerButtonsContainer___S657Q", o = "styles-module__lawyerPortalButton___WjsZK", e = "styles-module__lawyerSignUpButton___VA1ve", n = {
  lawyerButtonsContainer: t,
  lawyerPortalButton: o,
  lawyerSignUpButton: e
};
export {
  n as default,
  t as lawyerButtonsContainer,
  o as lawyerPortalButton,
  e as lawyerSignUpButton
};
